import { ReactNode } from 'react'
import { ICON_SIZE_SMALL } from '@carto/meridian-ds/theme'
import { HelpOutline } from '@mui/icons-material'
import { Tooltip, styled } from '@mui/material'

const HintIcon = styled(HelpOutline, {
  shouldForwardProp: (prop) => prop !== 'withGutter'
})<{ withGutter?: boolean }>(({ withGutter, theme }) => ({
  marginLeft: withGutter ? theme.spacing(0.5) : 0,
  width: ICON_SIZE_SMALL,
  height: ICON_SIZE_SMALL,
  fill: theme.palette.text.secondary
}))

interface Props {
  message: ReactNode
  withGutter?: boolean
}

function HelpTooltip({ message, withGutter }: Props) {
  return (
    <Tooltip title={message}>
      <HintIcon withGutter={withGutter} />
    </Tooltip>
  )
}

export default HelpTooltip
